// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wysiwyg_wrapper__eV_Ai"};